angular
    .module('vm.helpCenterApr21')
    .controller('SearchResultsController', SearchResultsController)

function SearchResultsController($scope, $http, $filter, $timeout) {
    const vm = this;
}